'use strict';

var tslib = require('tslib');
var React = require('react');
var bemReactClassname = require('bem-react-classname');
var desktop = require('@alfalab/core-components/input/desktop');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

/**
 * Компонент поля ввода, позволяющий отправлять значение после ввода определенного числа символов.
 */
var AutosubmitInput = /** @class */ (function (_super) {
    tslib.__extends(AutosubmitInput, _super);
    function AutosubmitInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cn = bemReactClassname.createCn('autosubmit-input');
        _this.inputRef = React__default.default.createRef();
        _this.handleChange = function (event, payload) {
            var _a = _this.props, onChange = _a.onChange, onFinished = _a.onFinished, requiredChars = _a.requiredChars;
            var value = payload.value;
            if (onChange) {
                onChange(event, payload);
            }
            if (requiredChars <= value.length && onFinished) {
                onFinished(event, payload);
            }
        };
        return _this;
    }
    AutosubmitInput.prototype.render = function () {
        var _a = this.props, requiredChars = _a.requiredChars; _a.onFinished; var inputProps = tslib.__rest(_a, ["requiredChars", "onFinished"]);
        return (React__default.default.createElement(desktop.InputDesktop, tslib.__assign({}, inputProps, { type: "tel", className: this.cn(), maxLength: requiredChars, ref: this.inputRef, onChange: this.handleChange })));
    };
    /**
     * Устанавливает фокус на поле ввода и выбирает весь текст в поле.
     */
    AutosubmitInput.prototype.focus = function () {
        var current = this.inputRef.current;
        current.focus();
        current.select();
    };
    /**
     * Снимает фокус с поля ввода.
     */
    AutosubmitInput.prototype.blur = function () {
        var current = this.inputRef.current;
        current.blur();
    };
    return AutosubmitInput;
}(React__default.default.PureComponent));

module.exports = AutosubmitInput;
